import { LoaderFunction } from "react-router-dom";
import { axiosApi } from "../../interceptors/axios";
import { PagedResponse } from "../../types/Result";
import { ExamTypeCategory } from "../examTypeCategory/type";

export const examTypeCategoryListLoader: LoaderFunction = async (args) => {
  const result = await axiosApi.get<PagedResponse<ExamTypeCategory>>(
    `/api/examTypeCategories?filters[0].field=examTypeCode&filters[0].operator=eq&filters[0].value=${args.params.examTypeCode}`
  );

  return result.data;
};
